
import React, { useEffect, useState } from "react";
import { useEffectOnce } from "usehooks-ts";
import { getContentProgress } from "~/api/productApi";
import { number } from "~/components/SharedLandingPageSection/SocialProofSection/SocialProofSection.css";
import { VideoProgressBar } from "~/components/videoProductPage/common/VideoProgressBar/VideoProgressBar";


export const UpdatingVideoProgressBar = ({
    productId,
    currentVideo,
    playlistVideoId,
    currentProgress
  }: {
    productId: string;
    currentVideo: string;
    playlistVideoId: string;
    currentProgress?: number
  }): React.ReactElement => {

    const [videoProgress, setVideoProgress] = useState(0);

    useEffect(() => {
      function getProductProgress() {
        getContentProgress(productId, playlistVideoId)
          .then(result => result.lastPositionPercentage)
          .then(result => setVideoProgress(result)).finally(() => {})
      }
      if(currentVideo == playlistVideoId){
        currentProgress ? setVideoProgress(currentProgress) : getProductProgress()
      }
      else if(videoProgress != 0){
        return
      }
      else{
        getProductProgress()
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentVideo, currentProgress])

    return (
        <VideoProgressBar barHeight={3} progressPercentage={videoProgress} borderRadius={3}/>
    )
  }